import { FC } from 'react'
import {
    Outlet
} from "react-router-dom";


const  TransportPage: FC = () => {  
    return (
        <Outlet />
    );
}

export default TransportPage